// 抗癌百科

import ManualDetails from '@/views/anticancer/manual/details/index.vue'
import ManualList from '@/views/anticancer/manual/list/index.vue'

import Questions from '@/views/anticancer/manual/list/index.vue'
import CurriculumDetails from '@/views/anticancer/curriculum/details/index.vue'
import Curriculum from '@/views/anticancer/curriculum/list/index.vue'

import DetailsDetails from '@/views/anticancer/diseaseBank/details/index.vue'

import DiseaseList from '@/views/anticancer/diseaseBank/list/index.vue'

import Anticancer from '@/views/anticancer/index'

const anticancerRoutes = [
    // 抗癌百科首页
    {
        path: '/anticancer',
        name: 'anticancer',
        meta: {
            title: '抗癌百科',
        },
        component: Anticancer
    },
    // 疾病库列表
    {
        path: '/diseaseList',
        meta: { index: 1, title: '疾病库'},
        name: 'diseaseList',
        component: DiseaseList
    },
    // 疾病库详情
    {
        path: '/details-details',
        name: 'details-details',
        meta: {
            index: 1,
            title: '疾病库'
        },
        component: DetailsDetails
    },
    {
        path: '/curriculum',
        name: 'curriculum',
        meta: {
            title: '抗癌公开课',
        },
        component: Curriculum
    },
    {
        path: '/curriculum-details/:id',
        name: 'curriculum-details',
        meta: {
            title: '抗癌公开课-详情'
        },
        component: CurriculumDetails
    },
    {
        path: '/manual',
        name: 'manual',
        meta: {
            title: '科普手册',
        },
        component: ManualList
    },
    {
        path: '/manual-details/:id',
        name: 'manual-details',
        meta: {
            title: '科普手册-详情'
        },
        component: ManualDetails
    },
    {
        path: '/questions',
        name: 'questions',
        meta: {
            title: ''
        },
        component: Questions
    }
]

export default anticancerRoutes



// WEBPACK FOOTER //
// ./src/router/anticancer.js